import { FlexBox, Icon } from '@fable/components'
import { css, useTheme } from '@fable/theme'

interface Props {
  onClick: () => void
}

export const HomeClubsSearchButton = ({ onClick }: Props) => {
  const { colors, motion, mediaQueries } = useTheme()

  return (
    <FlexBox
      className={css`
        background-color: ${colors.uiWhite};
        border-radius: 0 100px 100px 0;
        padding-left: 18px;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%) scale(1.1);
        z-index: 1;
        ${mediaQueries.mobileL} {
          padding-left: 0;
        }
      `}
    >
      <FlexBox
        className={css`
          width: 44px;
          height: 44px;
          background-color: ${colors.uiPearlExtraLight};
          border-radius: 50%;
          cursor: pointer;
          transform: scale(1.01);
          ${motion.transition('background-color')};
          ${mediaQueries.mobileL} {
            &:hover {
              background-color: ${colors.uiPearl};
            }
          }
        `}
        onClick={onClick}
        aria-label="search clubs"
        centerAll
      >
        <Icon
          className={css`
            width: 20px;
            height: 20px;
            svg path {
              fill: ${colors.graphite};
            }
          `}
          type="search"
        />
      </FlexBox>
    </FlexBox>
  )
}
